<template>
    <v-container>
      <h3>Agregar fotografia</h3>
        <v-divider></v-divider>
        <v-row>
            <v-col>
              <h5>Informaci&oacute;n del empleado</h5>
              <v-divider></v-divider>
                <h5>DUI: {{ item.dui }}</h5>
                <h5>Nombres: {{ item.nombres }}</h5>
                <h5>Apellidos: {{ item.apellidos }}</h5>
                <h5>Cargo: {{ item.cargo}}</h5>
                <h5>Area: {{ item.area }}</h5>
                <h5>Distrito: {{ item.distrito }}</h5>

                <v-divider></v-divider>
                <v-img
                :width="241"
                aspect-ratio="1/1"
                cover
                :src="item.url_foto"
                ></v-img>
            </v-col>
            <v-col>
              <h5>1 Selecciona una imagen</h5>
              <v-divider></v-divider>
                <v-file-input
                    label="Selecciona una imagen"
                    v-model="image"
                    accept="image/*"
                    @change="loadImage"
                ></v-file-input>
                <v-divider></v-divider>
                <h5 v-if="imageSrc">2 Recorta la imagen</h5>
                <v-divider></v-divider>
                <div ref="imageContainer" class="image-container">
                    <img ref="imageElement" :src="imageSrc" v-if="imageSrc" alt="Imagen a cortar" />
                </div>
                <v-btn :disabled="cargando" prepend-icon="mdi mdi-scissors-cutting" @click="cropImage" color="primary" v-if="image">Recortar Imagen</v-btn>
            </v-col>
            <v-col >
              <h5 v-if="image">3 Envia la imagen</h5>
                <v-img :width="400" aspect-ratio="1/1"  v-if="croppedImage" :src="croppedImage" alt="Imagen Recortada" />
                <v-divider></v-divider>
                <v-btn :disabled="cargando" @click="enviarImg" color="success" v-if="croppedImage" prepend-icon="mdi mdi-image-plus">Enviar</v-btn>
                <v-divider></v-divider>
                <v-alert v-if="cargando" title="Espere" text="Subiendo imagen" type="info"></v-alert>
                <v-alert v-if="cargandoError" title="Error" text="Algo salio mal!" type="error" closable></v-alert>
            </v-col>
        </v-row>
     
    </v-container>
  </template>
  
  <script>
  import axios from "axios";
import Cropper from "cropperjs";
  import "cropperjs/dist/cropper.css";
  
  export default {
    name:'cutterC',
    props:{
      item:Object
    },
    data() {
      return {
        //base de datos
        url:'http://127.0.0.1:8000/api/carnets',
        urlImg:'http://127.0.0.1:8000/api/img',
        config:{
                headers:{
                  'Authorization':'Bearer '+this.$store.getters.getToken
                }
            },
        pwdkey:'3JAmksLh0YeObnNM',
        //para recortar la imagen
        image: null,
        imageSrc: null,
        croppedImage: null,
        cropper: null,
        //para enviar al server
        imgUrl:null,
        objeto:{},
        //ux
        cargando:false,
        cargandoError:false
      };
    },
    methods: {
        obtenerDominio(){
              this.url = `${this.$store.state.dominio}/carnets`
              this.urlImg = `${this.$store.state.dominio}/img`
        },
        //para convertir a blob
        enviarImg(){
            this.cargando = true;
            this.$emit('cargando');
             // Convertir el data URL a Blob
            const dataUrl = this.croppedImage;
            const byteString = atob(dataUrl.split(',')[1]); // Obtener la parte binaria
            const mimeType = dataUrl.split(',')[0].match(/:(.*?);/)[1]; // Obtener el tipo MIME

            // Crear un ArrayBuffer
            const arrayBuffer = new ArrayBuffer(byteString.length);
            const uint8Array = new Uint8Array(arrayBuffer);

            // Llenar el ArrayBuffer con los datos decodificados
            for (let i = 0; i < byteString.length; i++) {
                uint8Array[i] = byteString.charCodeAt(i);
            }

            // Crear el Blob
            const blob = new Blob([uint8Array], { type: mimeType });

            const formData = new FormData;


            formData.append('image',blob,"img.png");
            formData.append('name',`${this.item.codigo}_${this.item.id}`);
            formData.append('pwdkey',`${this.pwdkey}`);

            axios.post(this.urlImg,formData,{
              headers:{
                  'Authorization':'Bearer '+this.$store.getters.getToken,
                  'Content-Type': 'multipart/form-data',
                }})
            .then(response=>{
                this.imgUrl = response.data.path;
                console.log(this.imgUrl);
                this.objeto = this.item;
                this.objeto.url_foto = this.imgUrl;
                this.objeto.pwdkey = this.pwdkey;
                this.cargando = false;
                this.actualizarCarnet();

            })
            .catch(error=>{
              this.cargando = false;
              this.cargandoError = true;
              this.$emit('cargandoError');
              console.log('error: ',error)
            })
        },
      //para la base de datos
      //actualiza el carnet
      actualizarCarnet(){
        axios.put(`${this.url}/${this.item.id}`,this.objeto,this.config)
        .then(response=>{
            if(response.data.code == 200){
              this.image= null
              this.imageSrc=null
              this.croppedImage= null
              this.cropper=null
              this.$emit('finalizado');
              this.$emit('cargandoError');
            }
        })
        .catch(error=>{
            console.log("error: ",error)
        })
      },
      //para cortar la imagen
      loadImage() {
        if (this.image) {
          const reader = new FileReader();
          reader.onload = () => {
            this.imageSrc = reader.result;
            this.$nextTick(this.initCropper);
          };
          reader.readAsDataURL(this.image);
        }
      },
      initCropper() {
        const imageElement = this.$refs.imageElement;
        if (imageElement) {
          this.cropper = new Cropper(imageElement, {
            aspectRatio: 1 / 1, // Relación de aspecto opcional
            viewMode: 1, // Modo de visualización de la imagen
            responsive: true,
            autoCropArea: 0.65,
            scalable: true,
            zoomable: true,
          });
        }
      },
      cropImage() {
        if (this.cropper) {
          const desiredWidth = 300; // Cambia a tu tamaño preferido
          const desiredHeight = 300; // Mantén la proporción o ajusta como necesites
            //console.log(this.item);
            const canvas = this.cropper.getCroppedCanvas({
                                width: desiredWidth,
                                height: desiredHeight,
                              });
            this.croppedImage = canvas.toDataURL();
        }
      },
    },
    watch: {
      image(newImage) {
        if (newImage) {
          this.imageSrc = null;
          this.croppedImage = null;
          if (this.cropper) {
            this.cropper.destroy();
            this.cropper = null;
          }
        }
      },
    },
    created(){
      this.obtenerDominio();
    }
  };
  </script>
  
  <style scoped>
  .image-container {
    width: 100%;
    text-align: center;
    margin: 20px 0;
  }
  
  .image-container img {
    max-width: 100%;
    height: auto;
  }
  .v-divider{
    margin-top: 10px;
    margin-bottom: 10px;
  }
  </style>
  